import Vue from 'vue'
import { getMenuTreeList,operMenu,searchMenu } from '@/api/menu'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const menu = {
  state: {
		menuTreeList:[],
		loading:false,
		permission:[{key:'add',title:'新增'},{key:'edit',title:'编辑'},{key:'del',title:'删除'},{key:'detail',title:'详情'},{key:'export',title:'导出'}],
		permissionMap:{add:{key:'add',title:'新增'},edit:{key:'edit',title:'编辑'},del:{key:'del',title:'删除'},detail:{key:'detail',title:'详情'},export:{key:'export',title:'导出'}}
	},

  mutations: {
    SET_MENU_TREE_LIST: (state,menuTreeList) => {
      state.menuTreeList = menuTreeList
    },
		SET_LOADING: (state,loading) => {
      state.loading = loading
    },
  },

  actions: { 
    // 获取用户信息
    getMenuTreeList ({ commit }) {
      return new Promise((resolve, reject) => {
        getMenuTreeList().then(response => {
					const result = response.data 
					commit('SET_MENU_TREE_LIST', result.menuList);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
		OperMenu ({ commit },record) {
		  return new Promise((resolve, reject) => {
		    operMenu(record).then(response => {  
					 console.log(response)
		    	 resolve(response)
		    	 }).catch(error => {
		    		 reject(error)
		     }) 
		  })
		},
		SearchMenu ({ commit },record) {
		  return new Promise((resolve, reject) => {
		    searchMenu(record).then(response => {  
					 console.log(response)
		    	 resolve(response)
		    	 }).catch(error => {
		    		 reject(error)
		     }) 
		  })
		},
  }
}

export default menu
